export default {
  base: {
    variant: 'spark.base.wrapper',
    fontFamily: 'base',
    color: 'inherit',
    lineHeight: '24px',
    textDecoration: 'underline',
    textUnderlineOffset: '6px',
    display: 'inline-block',
    hover: {
      textDecorationThickness: '2px'
    },
    focus: {
      variant: 'spark.element.link.base.hover',
      backgroundColor: 'cyan'
    }
  }
};